import { render, staticRenderFns } from "./Form418.vue?vue&type=template&id=0bc2e21a&scoped=true&"
import script from "./Form418.vue?vue&type=script&lang=js&"
export * from "./Form418.vue?vue&type=script&lang=js&"
import style0 from "./Form418.vue?vue&type=style&index=0&id=0bc2e21a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc2e21a",
  null
  
)

export default component.exports